import React from 'react'

const Spinner = () => {
    return (
        <div className="spinner-wrapper">
            <div className="donut"></div>
        </div>
    )
}

export default Spinner
